<template>
  <div
    style="position: relative"
    class="img-result-center margin-bottom-25"
    :style="{ width: data_page.data_image.width + 'pt', height: data_page.data_image.height + 'pt' }"
  >
    <canvas ref="canvas" class="page-canvas" style="position: absolute; left: 0; top: 0; z-index: 0"></canvas>
    <canvas ref="highlight-canvas" style="position: absolute; left: 0; top: 0; z-index: 1"></canvas>
    <!--Plagiarism Mode-->
    <div v-if="documentResultMode === 'plagiarismMode'">
      <div
        v-for="(result_plag, index) in data_page.data_plagiarism"
        :key="result_plag.id"
        class=""
        :id="'selectorPlagResult-' + result_plag.id"
        :index="index"
      >
        <undo-button
          :left="data_page.data_image.width - 35 + 'pt'"
          :top="result_plag.parts[0].highlights[0].top + 'pt'"
          :result_plag="result_plag"
          @undo="
            () => {
              undoAct(result_plag)
            }
          "
        ></undo-button>
        <div
          v-if="
            noPlagCurrentPopup === result_plag['id'] &&
            noPagePlagCurrentPopup === data_page.pageId &&
            isShowPlagPopup &&
            !isShowIgnoreByUserForm
          "
        >
          <PlagiarismPopup
            :is-group-document="isGroupResult"
            :is-ignored-options="document_type === 'document'"
            :data-image="data_page.data_image"
            @showIgnoreForm="showIgnoreForm($event)"
            @reload-group="handleReloadGroup($event)"
          />
        </div>
      </div>
      <IgnoreByUserForm
        v-if="isShowIgnoreByUserForm"
        :mode="currentIgnoreUserFormMode"
        @done="closeIgnoreForm()"
        @reload-group="handleReloadGroup($event)"
      />
    </div>

    <!-- Spelling Mode -->
    <div v-else-if="documentResultMode === 'spellingMode'">
      <div v-if="data_page.data_spelling && data_page.data_spelling.length > 0">
        <div v-for="(data, i) in data_page.data_spelling" :key="i">
          <el-tooltip placement="top" :content="formattedEditString[i]">
            <div
              class="spell-item"
              :style="{
                top: data.top + 'pt',
                left: data.left + 'pt',
                width: data.width + 'pt',
                height: data.height + 'pt',
              }"
            />
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlagiarismPopup from './PlagiarismPopup'
import IgnoreByUserForm from './IgnoreByUserForm'
import { ColorPlagIgnored, ColorPlagLevel, ColorPlagUserIgnored } from '@/constants/ThemeConstant'
import { apiDownloadAsArrayBuffer } from '@/services/document_management_service'
import _ from 'lodash'
import { getLevelPlagiarism } from '@/services/doit_result_service'
import { DocumentTypes, IgnoreUserFormMode, reloadGroupType } from '@/constants/DoITConstant'
import UndoButton from '@/components/ResultDocument/UndoButton'

export default {
  name: 'PageResult',
  components: {
    UndoButton,
    PlagiarismPopup,
    IgnoreByUserForm,
  },
  props: {
    data_page: {
      type: Object,
    },
    document_type: {
      type: String,
    },
    index: {
      type: Number,
    },
  },
  data: function () {
    return {
      // selectorPlagResult: '',
      xPopup: 0,
      yPopup: 0,
      heightPopup: 200,
      widthPopup: 600,
      titlePopup: '',
      sourceContentPopup: '',
      resultPlagCurrentPopup: '',
      resultLineCurrentPopup: '',
      isShowIgnoreByUserForm: false,
      currentIgnoreUserFormMode: IgnoreUserFormMode.NEW,
      reloadGroupType,
    }
  },
  mounted() {
    this.redrawCanvas()
    this.redrawHighlightCanvas()
  },
  methods: {
    async redrawCanvas() {
      let canvasElement = this.$refs.canvas
      let ctx = canvasElement.getContext('2d')
      canvasElement.style.width = '100%'
      canvasElement.style.height = '100%'

      canvasElement.width = canvasElement.offsetWidth
      canvasElement.height = canvasElement.offsetHeight

      const url = this.data_page.data_image.url
      ctx.drawImage(
        await createImageBitmap(new Blob([new Uint8Array(await apiDownloadAsArrayBuffer(url))])),
        0,
        0,
        canvasElement.offsetWidth,
        canvasElement.offsetHeight
      )
      canvasElement.oncontextmenu = function (e) {
        e.preventDefault()
      }
    },
    redrawHighlightCanvas() {
      let highlightCanvas = this.$refs['highlight-canvas']
      let highlightCtx = highlightCanvas.getContext('2d')

      highlightCanvas.style.width = '100%'
      highlightCanvas.style.height = '100%'

      highlightCanvas.width = highlightCanvas.offsetWidth
      highlightCanvas.height = highlightCanvas.offsetHeight

      highlightCtx.clearRect(0, 0, highlightCanvas.width, highlightCanvas.height)

      const pt2px = (pt) => {
        return (pt * 4) / 3
      }

      if (this.documentResultMode === 'plagiarismMode') {
        Object.entries(this.data_page.data_plagiarism).forEach((entry) => {
          const [groupId, simi] = entry
          highlightCtx.beginPath()
          const fontSize = 13
          highlightCtx.font = '600 ' + fontSize + 'px "Open Sans", sans-serif'
          const flag_width = highlightCtx.measureText(simi.id).width + 10
          const flag_height = 1.333 * fontSize
          const flag_x = pt2px(simi.parts[0].highlights[0].left - 20)
          const flag_y = pt2px(simi.parts[0].highlights[0].top - 5)
          highlightCtx.rect(flag_x, flag_y, flag_width, flag_height)
          highlightCtx.fillStyle = 'rgba(255, 93, 0, 0.75)'
          highlightCtx.fill()

          highlightCtx.fillStyle = 'white'
          highlightCtx.lineWidth = 4
          highlightCtx.fillText(simi['id'], flag_x + 5, flag_y + flag_height / 1.4)

          const levelPlag = this.getLevelPlag(simi)
          _.flatMap(simi.parts, (part) => part.highlights).forEach((line) => {
            highlightCtx.beginPath()
            highlightCtx.rect(pt2px(line.left), pt2px(line.top), pt2px(line.width), pt2px(line.height))
            highlightCtx.fillStyle = levelPlag
            highlightCtx.fill()
          })
        })
        // ctx.stroke()
      } else if (this.documentResultMode === 'spellingMode') {
        this.data_page.data_spelling.forEach((value) => {
          highlightCtx.beginPath()
          highlightCtx.rect(pt2px(value.left), pt2px(value.top), pt2px(value.width), pt2px(value.height))
          highlightCtx.fillStyle = 'rgba(255, 0, 0, 0.5)'
          highlightCtx.fill()
        })
      }

      highlightCanvas.addEventListener('click', (e) => {
        const pos = {
          x: e.offsetX,
          y: e.offsetY,
        }
        if (this.documentResultMode === 'plagiarismMode') {
          Object.entries(this.data_page.data_plagiarism).forEach((entry) => {
            const [groupId, value] = entry
            _.flatMap(value.parts, (part) => part.highlights).forEach((highlight) => {
              let x_pos = pt2px(highlight.left)
              let y_pos = pt2px(highlight.top)
              if (
                pos.x > x_pos &&
                pos.x < x_pos + pt2px(highlight.width) &&
                pos.y > y_pos &&
                pos.y < y_pos + pt2px(highlight.height)
              ) {
                this.onClickResultPlag(e, value, highlight)
              }
            })
          })
        } else if (this.documentResultMode === 'spellingMode') {
          this.data_page.data_spelling.forEach((spellingError, index) => {
            let x_pos = pt2px(spellingError.left)
            let y_pos = pt2px(spellingError.top)
            if (
              pos.x > x_pos &&
              pos.x < x_pos + pt2px(spellingError.width) &&
              pos.y > y_pos &&
              pos.y < y_pos + pt2px(spellingError.height)
            ) {
              this.onClickSpelling(index)
            }
          })
        }
      })

      highlightCanvas.oncontextmenu = function (e) {
        e.preventDefault()
      }
    },
    onClickResultPlag(e, result_plag, line) {
      let pageCurrent = line['pageId']
      let tmpPlag = this.lstResultPlagIgnoredCurrent.find((e) =>
        e.sentenceIds.includes(result_plag.parts[0].sentenceId)
      )
      if (tmpPlag) {
        result_plag = JSON.parse(JSON.stringify(result_plag))
        result_plag.isIgnored = tmpPlag.isIgnored
        result_plag.ignoredReason = tmpPlag.reasonIgnoreType
      }
      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', false)
      this.$store.dispatch('docRes/plagiarism/updatePlagNo', result_plag['id'])
      this.$store.dispatch('docRes/plagiarism/updateNoPagePlagCurrentPopup', pageCurrent)
      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', true)
      this.$store.dispatch('docRes/plagiarism/updateResultPlagCurrentPopup', result_plag)
      this.$store.dispatch('docRes/plagiarism/updateResultLineCurrentPopup', line)

      // document.getElementById(`selectorPlagLineResult-${result_plag.id}-${line.lineId}`).scrollIntoView({
      //     behavior: 'auto',
      //     inline: 'center'
      // })
      //
      // document.getElementById(`plag-card-${result_plag.id}`).scrollIntoView({
      //     behavior: 'auto',
      //     inline: 'center'
      // })
      this.$emit('click-result', result_plag.id)

      document.getElementById(`page-preview-${pageCurrent}`).scrollIntoView({
        behavior: 'auto',
        inline: 'center',
      })
    },
    onClickSpelling(ind) {
      let pageCurrent = this.data_page.pageId
      this.$store.dispatch(
        'docRes/spelling/updateCurrentSpellingTooltip',
        this.currentSpellingTooltip === ind ? -1 : ind
      )

      this.$store.dispatch('docRes/spelling/updateIsShowSpellingPageDetail', true)
      this.$store.dispatch('docRes/spelling/updateCurrentSpellingPageDetail', pageCurrent)
      document.getElementById(`spelling-detail-card-${pageCurrent}-${ind}`).scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      })
    },
    // onMouseOver(e, data_page) {
    //     if (this.$store.getters['docRes/plagiarism/noPagePlagCurrentPopup'] !== data_page['pageId']) {
    //         this.$store.dispatch('docRes/plagiarism/updateNoPagePlagCurrentPopup', data_page['pageId'])
    //         document.getElementById(`page-preview-${data_page['pageId']}`).scrollIntoView({
    //             behavior: 'auto',
    //             inline: 'center'
    //         })
    //     }
    // },
    getLevelPlag(result_plag) {
      if (result_plag['isIgnoredBySystem']) {
        return ColorPlagIgnored
      }
      if (result_plag['isIgnored']) {
        return ColorPlagUserIgnored
      }
      return (
        ColorPlagLevel[getLevelPlagiarism(result_plag.score, this.configDocumentScore)] || ColorPlagLevel['unknown']
      )
    },
    undoAct(resultPlag) {
      this.redrawHighlightCanvas()
      this.reloadGroup(resultPlag.id, reloadGroupType.UNDO_ACTION)
    },
    reloadGroup(groupId, type) {
      console.log('result_plag', groupId, type)
      this.$emit('reload-group', { groupId, type })
    },
    handleReloadGroup({ resultPlag, type }) {
      this.reloadGroup(resultPlag.id, type)
    },
    showIgnoreForm(mode) {
      this.currentIgnoreUserFormMode = mode
      this.isShowIgnoreByUserForm = true
    },
    closeIgnoreForm() {
      this.isShowIgnoreByUserForm = false
    },
  },
  computed: {
    noPlagCurrentPopup() {
      return this.$store.getters['docRes/plagiarism/noPlagCurrentPopup']
    },
    noPagePlagCurrentPopup() {
      return this.$store.getters['docRes/plagiarism/noPagePlagCurrentPopup']
    },
    isShowPlagPopup() {
      return this.$store.getters['docRes/plagiarism/isShowPlagPopup']
    },
    documentResultMode() {
      return this.$store.getters['docRes/documentResultMode']
    },
    currentSpellingTooltip() {
      return this.$store.getters['docRes/spelling/currentSpellingTooltip']
    },
    currentSpellingPageDetail() {
      return this.$store.getters['docRes/spelling/currentSpellingPageDetail']
    },
    lstResultPlagIgnoredCurrent() {
      return this.$store.getters['docRes/plagiarism/lstResultPlagIgnoredCurrent']
    },
    configDocumentScore() {
      return this.$store.getters['docRes/plagiarism/getConfigDocumentScore']
    },
    formattedEditString() {
      if (!this.data_page.data_spelling || this.data_page.data_spelling.length < 1) return []
      return this.data_page.data_spelling.map((error) => {
        const editWords = error.edit
        if (!editWords || editWords.length < 1) return 'Không có gợi ý'
        return editWords.join(', ')
      })
    },
    isGroupResult() {
      return this.$route.params.type === DocumentTypes.GROUP_DOCUMENT
    }
  },
  watch: {
    data_page: function () {
      this.redrawHighlightCanvas()
    },
    documentResultMode: function () {
      this.redrawHighlightCanvas()
    },
    lstResultPlagIgnoredCurrent: function () {
      this.redrawHighlightCanvas()
    },
  },
}
</script>
<style>
.line_plag,
.spell-item {
  position: absolute;
  cursor: pointer;
  margin: 0;
}

.spell-item {
  /*background-color: rgba(255, 0, 0, 0.5);*/
  z-index: 1;
}

.mark_no_plag {
  display: inline-block;
  padding: 0 3px;
  background-color: rgba(255, 93, 0, 0.75);
  color: white;
  font-size: 13px;
  border-radius: 2px;
  position: absolute;
}

.tooltip.spelling-error .tooltip-inner {
  background: green;
  color: white;
}

.tooltip.spelling-error .tooltip-inner span {
  font-weight: 600;
}

.tooltip.spelling-error .tooltip-arrow {
  border-color: green;
}

.img-result-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.page-canvas {
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0);
}
</style>
